import React from 'react';
import { IDigitalHealthProfile } from '../UI/SelectedSalesOrder/DigitalHealthProfileTab';

import { DocumentList } from '../DocumentList/DocumentList';
import { ContentViewer } from '../ContentViewer/ContentViewer';
import BackButton from '../UI/Buttons/BackButton';
import SaveTextArea from '../ConsultationParentComponent/SaveTextArea/SaveTextArea';
import classes from './DHPConsultationDetails.module.css';
import { useTranslation } from '../../hooks/useTranslations';

interface OnlineResult extends IDigitalHealthProfile {
  sales_order_id: string;
  sales_order_item_id: string;
  work_order_id: string;
  work_order_status_id: string;
  person_account_number: string;
  customer_person_id: string;
  product_order_id_out: string;
}

type Props = {
  onlineResult: OnlineResult;
  handleClose: () => void;
};
const ConsultationDetails: React.FC<Props> = ({ onlineResult, handleClose }) => {
  const { translations } = useTranslation();

  const consultationData = React.useMemo(() => {
    return onlineResult?.online_consultation ? onlineResult.online_consultation[0] : undefined;
  }, [onlineResult]);

  const documentData = onlineResult?.attachments ?? [];

  const groupedDocuments = React.useMemo(() => {
    return documentData.reduce((doc: Record<string, typeof documentData>, docs) => {
      if (!doc[docs.attachment_type_description]) {
        doc[docs.attachment_type_description] = [];
      }
      doc[docs.attachment_type_description].push(docs);
      return doc;
    }, {});
  }, [documentData]);

  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <div className={classes.title}>
          <BackButton onClick={() => handleClose()} disableMargin iconOnly />
          {translations('dhpConsultationDetails.doctor')}: {consultationData?.doctor_name}
        </div>
      </div>

      <ContentViewer
        style={{ margin: '0px' }}
        title={translations('dhpConsultationDetails.findings')}
        content={''}
        isCollapsible
      >
        <div className={classes.textContainer}>
          <div className={classes.answer}>
            {consultationData?.findings && (
              <div dangerouslySetInnerHTML={{ __html: consultationData?.findings ?? '' }} />
            )}
          </div>
        </div>
      </ContentViewer>
      <ContentViewer
        style={{ margin: '0px' }}
        title={translations('dhpConsultationDetails.recommendations')}
        content={''}
        isCollapsible
      >
        <div className={classes.textContainer}>
          <div className={classes.answer}>
            {consultationData?.recommandation && (
              <div dangerouslySetInnerHTML={{ __html: consultationData?.recommandation ?? '' }} />
            )}
          </div>
        </div>
      </ContentViewer>

      <ContentViewer
        style={{ margin: '0px' }}
        title={translations('documents')}
        content={''}
        isCollapsible
        className={classes.customContentViewer}
      >
        <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
          {Object.entries(groupedDocuments).map(([attachmentTypeDescription, docs]) => (
            <ContentViewer
              style={{ marginBottom: '10px', width: '100%' }}
              key={attachmentTypeDescription}
              title={translations(
                `label.attachment_description_${attachmentTypeDescription
                  .replace(/ /g, '_')
                  .toLowerCase()}`
              )}
              content={''}
              isCollapsible
              className={classes.customContentViewer}
            >
              <DocumentList documents={docs} fullWidth />
            </ContentViewer>
          ))}
        </div>
      </ContentViewer>
      <ContentViewer
        style={{ margin: '0px' }}
        title={translations('sick_leave')}
        content={''}
        isCollapsible
      >
        <SaveTextArea type="sickLeave" selectedConsultation={onlineResult} />
      </ContentViewer>

      <ContentViewer
        style={{ margin: '0px' }}
        title={translations('prescription')}
        content={''}
        isCollapsible
      >
        <SaveTextArea type="prescription" selectedConsultation={onlineResult} />
      </ContentViewer>
    </div>
  );
};
export { ConsultationDetails };
